// Keep in sync with app/lib/enums/brand_sku_mapper_mfr_to_dp_enums.py
// Reverse direction (manufacturer product -> distributor products). No population
// dimension. Status / review status / action are identical to V1/V2.

export const BrandSkuMapperMfrToDpRunStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const BrandSkuMapperMfrToDpReviewStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  NO_MATCH: 'NO_MATCH',
};

export const BrandSkuMapperMfrToDpReviewAction = {
  APPROVE: 'approve',
  REJECT: 'reject',
  NO_MATCH: 'no_match',
  PICK: 'pick',
};

// No "Rejected" tab: one MFR product maps to many DPs, so the only negative
// signal that makes sense is "no candidate matches" (No Match). There is no
// per-candidate reject.
export const BRAND_SKU_MAPPER_MFR_TO_DP_REVIEW_STATUS_TABS = [
  { key: '', label: 'All' },
  { key: BrandSkuMapperMfrToDpReviewStatus.PENDING, label: 'Pending' },
  { key: BrandSkuMapperMfrToDpReviewStatus.IN_PROGRESS, label: 'In Progress' },
  { key: BrandSkuMapperMfrToDpReviewStatus.APPROVED, label: 'Approved' },
  { key: BrandSkuMapperMfrToDpReviewStatus.NO_MATCH, label: 'No Match' },
];

export const BrandSkuMapperMfrToDpTier = {
  HIGH: 'high',
  LOW: 'low',
  NO_MATCH: 'no_match',
};

export const BrandSkuMapperMfrToDpRunRequestField = {
  REMAINING_ONLY: 'remaining_only',
  MODEL_VERSION: 'model_version',
  MAX_PRODUCTS: 'max_products',
  MANUFACTURER_ID: 'manufacturer_id',
  BRAND_ID: 'brand_id',
  DISTRIBUTOR_ID: 'distributor_id',
  INFLUENCE_ONLY: 'influence_only',
  CAMPAIGN_ONLY: 'campaign_only',
};
